import { render } from "./testMail.vue?vue&type=template&id=7d72890e&ts=true"
import script from "./testMail.vue?vue&type=script&lang=ts"
export * from "./testMail.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__